/**
 * RTK Query / fetchBaseQuery error shapes for user-state mutations.
 */
export function getUserStateMutationErrorMeta(error: unknown): {
  httpStatus?: number;
  isVersionConflict: boolean;
} {
  if (!error || typeof error !== "object") {
    return { isVersionConflict: false };
  }

  const e = error as {
    status?: number;
    data?: unknown;
    error?: { status?: number; data?: unknown };
  };

  if (e.status === 409 && e.data && typeof e.data === "object") {
    return { httpStatus: 409, isVersionConflict: true };
  }

  if (e.error && typeof e.error === "object") {
    const inner = e.error as { status?: number; data?: unknown };
    if (inner.status === 409 && inner.data && typeof inner.data === "object") {
      return { httpStatus: 409, isVersionConflict: true };
    }
  }

  const httpStatus =
    typeof e.status === "number"
      ? e.status
      : typeof e.error?.status === "number"
        ? e.error.status
        : undefined;

  return { httpStatus, isVersionConflict: false };
}
